import {useSelector} from 'react-redux';
import {Redirect, Switch} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Session} from 'nutshell-core/session';
import type {User} from 'nutshell-core/types';

import type {NutshellState} from '../../store';
import {EngagementBarLeadsPage} from '../../ui/inbox/engagement-leads/engagement-bar-leads-page';
import {shouldHideSidebar} from '../../ui/inbox/helpers';
import {InboxPage, INBOX_SEARCH} from '../../ui/inbox/inbox-page';
import {PageWrapper} from '../../ui/layout/page-wrapper';
import {DASHBOARD, ENGAGEMENT_BAR_LEADS} from '../../ui/reports/report-types';

import {RestrictedPageRoute} from '../shared/restricted-page-route';

import {EngagementSidebarWrapper} from './engagement-sidebar-wrapper';

type Props = ContextRouter & {
    user: User | null | undefined;
};

const ENGAGEMENT_BAR_LEADS_SEARCH = 'ENGAGEMENT_BAR_LEADS_SEARCH';

export function EngagementRoot(props: Props) {
    const userPermissions = useSelector((state: NutshellState) =>
        Session.getUserPermissions(state)
    );

    const pathname = window.location.pathname;

    return (
        <PageWrapper
            sidebar={
                shouldHideSidebar(pathname) ? null : (
                    <EngagementSidebarWrapper user={props.user} isEmbedded={false} {...props} />
                )
            }
        >
            <Switch>
                <Redirect exact={true} from='/inbox' to='/inbox/dashboard' />
                <Redirect exact={true} from='/inbox/sms' to='/inbox/sms/open' />
                <Redirect exact={true} from='/inbox/settings' to='/inbox/settings/sms' />
                <Redirect
                    exact={true}
                    from='/inbox/settings/chat'
                    to={
                        NutClientConfig.hasNudgesForChatFF
                            ? '/inbox/settings/chat/engagement-bar'
                            : '/inbox/settings/chat/config'
                    }
                />
                <RestrictedPageRoute
                    // @ts-expect-error
                    exact={true}
                    path='/inbox/leads'
                    component={EngagementBarLeadsPage}
                    reportKey={ENGAGEMENT_BAR_LEADS}
                    localStorageKey={ENGAGEMENT_BAR_LEADS_SEARCH}
                    hasAccess={Boolean(userPermissions?.canUseOrTryInbox)}
                    redirectPath='/inbox/no-access'
                />
                <Redirect
                    exact={true}
                    from='/inbox/chatbot-threads'
                    to='/inbox/chatbot-threads/active'
                />
                <RestrictedPageRoute
                    // @ts-expect-error
                    exact={true}
                    path='/inbox/:section/:page?/:id?'
                    component={InboxPage}
                    reportKey={DASHBOARD}
                    localStorageKey={INBOX_SEARCH}
                    hasAccess={Boolean(userPermissions?.canUseOrTryInbox)}
                    redirectPath='/inbox/no-access'
                />
            </Switch>
        </PageWrapper>
    );
}
